import React from "react";

import {
	TableBody,
	TableCell,
	TableRow,
} from "@mui/material";
import { formatCurrency, formatLabel } from "../../../utils/utilityFunctions"
import { TextButton } from "../../../components/Buttons";
// import './style.css';

export default function LedgerSummaryTable(props) {

	const handleClick = (name) => {
		props.setSelectedLedgerCallback(name)
	}

	return (
		<>
			<TableBody>
				<TableRow hover>
					<TableCell
						align="left"
						variant="body2"
					>
						{formatLabel(props.data.name)}
					</TableCell>
					<TableCell
						align="right"
						variant="body2"
					>
						{formatCurrency(props.data.totalDebitAmount)}
					</TableCell>
					<TableCell align="right" variant="body2">
						{formatCurrency(props.data.totalCreditAmount)}
					</TableCell>
					<TableCell align="right" variant="body2">
						<b>{formatCurrency(props.data.balance)}</b>
					</TableCell>
					<TableCell align="center" variant="body2">
						<TextButton variant="text" onClick={() => handleClick(props.data)}>View</TextButton>
					</TableCell>
				</TableRow> 
			</TableBody>
		</>
	)
}